// src/api/axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://expertise.gov.kz/api',
  // baseURL: 'http://localhost:8000/api',
  withCredentials: true, // <-- важно для web-роутов/скачиваний по сессии
  headers: {
    Accept: 'application/json',
    // НЕ задаём Content-Type глобально — пусть axios подбирает сам
  },
  // optional:
  // timeout: 20000,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const lang = localStorage.getItem('locale') || 'kz';

    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    if (lang)  config.headers['Accept-Language'] = lang;

    // X-Socket-ID для toOthers() в Laravel Broadcasting
    const socketId = window.Echo?.socketId?.();
    if (socketId) config.headers['X-Socket-ID'] = socketId;

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginPage = window.location.pathname.includes("login");

      // Редиректим только если НЕ на странице логина
      if (!isLoginPage) {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        sessionStorage.clear();
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
